import React from 'react';
import PropTypes from 'prop-types';

import { TextLink } from '@vds/buttons';
import { Row, Col } from '@vds/grids';
import { Line } from '@vds/lines';
import { Title, Body } from '@vds/typography';

import PhoneNumberSelection from './phoneNumberSelection';
import { isMobile } from '../../../../../common/Helpers';
import { Margin } from '../../../../../common/styles';
import { ModalButtonContainer, ButtonWrapper } from './HomePhone.styles';

class SelectPhoneNumber extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      npanxxNumber: null,
    };
  }

  render() {
    const {
      selectedAddressOption,
      closeModal,
      changeLink,
      handleZipCodeChange,
      zipCode,
      displayError,
      mtnSelection,
      addHomePhoneButtonClick,
      enableAddHomeButton,
      enablePhoneNumberDropdown,
      propsList,
      landline,
    } = this.props;

    const buttonClasses = isMobile() ? 'width100 marginTop100' : 'marginTop80';

    const zipcodeError = !!(propsList && propsList.getNPANXX && propsList.getNPANXX.errors);
    return (
      <>
        <Row>
          <Col>
            <Title primitive="h3" size="medium">
              {landline && landline.emergency_ADDRESS_header}
            </Title>
          </Col>
        </Row>
        <Row>
          <Col>
            <Row>
              <Col>
                <Margin top="10px" bottom="10px">
                  <Body size="large" primitive="p" color="#6F7171" data-cs-mask>
                    {selectedAddressOption}
                  </Body>
                </Margin>
              </Col>
              <Col>
                <Margin top="10px" bottom="10px" left="20px">
                  <TextLink onClick={changeLink} analyticstrack="5g-change-home-phone-service" data-track="true" size="small">
                    {(landline && landline.change_link) || 'Change'}
                  </TextLink>
                </Margin>
              </Col>
            </Row>
          </Col>
        </Row>
        <Line type="secondary" surface="light" />
        <Margin bottom="10px">
          <PhoneNumberSelection
            disabled={!enablePhoneNumberDropdown}
            propsList={propsList}
            zipCode={zipCode}
            displayError={displayError}
            mtnSelection={mtnSelection}
            defaultDropDownValue={this.state.npanxxNumber}
            handleZipCodeChange={handleZipCodeChange}
            landline={landline}
          />
        </Margin>

        <div className="addonBtnWrapper">
          <ModalButtonContainer className={buttonClasses}>
            <ButtonWrapper
              isDisabled={zipcodeError ? true : !enableAddHomeButton}
              buttonName="Add Home Phone"
              analyticstrack="5G-add-Phone-addressInfoView"
              // data-track={enableContinueButton}
              disabled={zipcodeError ? true : !enableAddHomeButton}
              onClickContinue={addHomePhoneButtonClick}
              closeModal={closeModal}
            />
          </ModalButtonContainer>
        </div>
      </>
    );
  }
}

SelectPhoneNumber.propTypes = {
  selectedAddressOption: PropTypes.any,
  landline: PropTypes.object,
  closeModal: PropTypes.func,
  changeLink: PropTypes.func,
  propsList: PropTypes.object,
  handleZipCodeChange: PropTypes.func,
  zipCode: PropTypes.string,
  displayError: PropTypes.bool,
  mtnSelection: PropTypes.func,
  addHomePhoneButtonClick: PropTypes.func,
  enableAddHomeButton: PropTypes.bool,
  enablePhoneNumberDropdown: PropTypes.bool,
};
export default SelectPhoneNumber;
